import React, { useEffect, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { calculateRemainingHeight } from "../../../util";
import { Box, Drawer, ListItemText, useMediaQuery, useTheme } from "@mui/material";
import { v4 } from "uuid";

// interface ChartProps {
//   data: I_MACHINE_VIEW[] | I_PRODUCT_VIEW[];
// }

export const TimelineChart = ({ current_page_data, chart_key }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [series, setSeries] = useState([]);

  const [drawer_open, set_drawer_open] = useState(false);

  useEffect(() => {
    const { data } = current_page_data;
    // console.log({ data });
    if (data) {
      setSeries((prev) => [
        {
          data
        },
      ]);
    }
  }, [current_page_data]);

  // useEffect(() => {
  //   console.log({ series });
  // }, [series]);

  const [clicked_data, set_clicked_data] = useState(null);

  let timer = useRef(null);

  useEffect(() => {
    if (clicked_data !== null) {
      // console.log({ clicked_data });
      if (timer.current) {
        console.log("resetting timer");
        clearTimeout(timer.current);
      }
      // timer.current = setTimeout(() => {
      //   set_clicked_data(null);
      // }, 10000);
    }
    // else {
    //   console.log("null right now");
    // }
    return () => {
      if (timer.current) {
        console.log("cleaning up timeout");
        // clearTimeout(timer.current);
      }
    };
  }, [clicked_data]);

  // useEffect(() => {
  //   console.log("called in timeline chart...", series);
  // }, [series]);

  return (
    <div>
      {
        <Drawer anchor="right" open={drawer_open} onClose={() => {
          if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
          }
          set_drawer_open(false);
        }}>
          <Box className={`${isMobile ? "w-full" : "w-[450px]"}`} role="presentation">
            <Box className="p-4 bg-black text-white uppercase">
              {chart_key} : {clicked_data?.x}
            </Box>
            {
              clicked_data !== null && clicked_data &&
              Object.keys(clicked_data?.data || {}).map((text, index) => {
                if (clicked_data.data[text]) {
                  return (
                    <Box key={text} className={`p-2 px-4 flex justify-between border items-center`}>
                      <ListItemText primary={text.split("_").join(" ")} className="uppercase" />
                      {
                        clicked_data.data[text] instanceof Date ?
                          <ListItemText className="text-end" primary={clicked_data.data[text].toLocaleString()} /> :
                          typeof clicked_data.data[text] === "string" ?
                            <Box>
                              {
                                clicked_data.data[text].split(",").map((val, idx) =>
                                  <Box key={`drawer_item-${text}-${val}-${idx}`}>
                                    {val}
                                  </Box>)
                              }
                            </Box>
                            :
                            <ListItemText className="text-end" primary={typeof clicked_data.data[text] === "boolean" ? clicked_data.data[text] ? "Yes" : "No" : clicked_data.data[text]} />
                      }
                      {/* <ListItemButton>
                  </ListItemButton> */}
                    </Box>
                  );
                }
              })
            }
          </Box>
        </Drawer>
      }
      {series && series[0] && series[0]?.data && (
        <ReactApexChart
          options={{
            stroke: {
              width: 0.5,
              colors: ["#00000080"]
            },
            tooltip: {
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const { data } = w.globals?.initialSeries[seriesIndex]?.data[dataPointIndex];
                // console.log({ data });
                // const item = w?.globals?.seriesXvalues?.[seriesIndex]?.[dataPointIndex] || {};
                let details = "";
                // if (item.data.extra_key) {
                //   for (const key in item.data) {
                //     if (
                //       item.data.hasOwnProperty(key) &&
                //       key !== "start_time" &&
                //       key !== "end_time" &&
                //       key !== "extra_key"
                //     ) {
                //       details += `<p>${key}: ${item.data[key]}</p>`;
                //     }
                //   }
                // }
                Object.keys(data).forEach((key_name, idx) => {
                  if (key_name === "extra_key") {
                  } else {
                    const val = data?.[key_name];
                    if (data && key_name && val && typeof val === "string") {
                      details += `<div class='p-2 flex justify-between items-center border'>${key_name}: ${val
                        .split(";")
                        .map((val) => `<div>${val.split(",").map(txt => `<p>${txt}</p>`).join("")}</div>`)
                        .join("")}</div>`;
                    }
                    else if (val instanceof Date) {
                      details += `<div class='p-2 flex justify-between items-center border'>
                      ${key_name}: <div>
                       ${val.toLocaleString()}
                      </div>
                      </div>`;
                    }
                  }
                });
                return `<div div style = "rounded-sm" >
                        <h5 class='bg-black text-white rounded-t-sm p-4 uppercase'>${chart_key?.split("_")?.join(" ")}: ${data?.[chart_key] || data?.product_code || "no data..."}</h5>
                  ${details}
                </div>`;
              },
            },
            chart: {
              type: "rangeBar",
              events: {
                dataPointSelection: (event, chartContext, config) => {
                  event.preventDefault();
                  event.stopPropagation();
                  const { dataPointIndex, w } = config;
                  const { globals: { initialSeries } } = w;
                  const selected_data = initialSeries[0].data[dataPointIndex];
                  // console.log({ event, chartContext, config });
                  // console.log({ selected_data, initialSeries, dataPointIndex });
                  try {
                    if (selected_data && set_clicked_data) {
                      if (timer.current) {
                        clearTimeout(timer.current);
                        timer.current = null;
                      }
                      setTimeout(() => {
                        // console.log("setting");
                        set_drawer_open(true);
                        set_clicked_data(selected_data);
                      }, 10);
                    }
                  } catch (error) {
                    console.log({ error });
                  }
                },
                dataPointMouseEnter: function (event) {
                  event.target.style.cursor = "pointer";
                }
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
                distributed: true,
                dataLabels: {
                  hideOverflowingLabels: false,
                },
              },
            },
            dataLabels: {
              // enabled: true,
              // formatter: function (val: any, opts: any) {
              //   var a = new Date(val[0]);
              //   var b = new Date(val[1]);
              //   var diff = Math.abs(a.getTime() - b.getTime());
              //   return diff / (1000 * 60 * 60) + " hours";
              // },
              style: {
                colors: ["#f3f4f5", "#fff"],
              },
            },
            xaxis: {
              type: "datetime",
              position: "top"
            },
            yaxis: {
              show: true,
            },
            grid: {
              row: {
                colors: ["#f3f4f5", "#fff"],
                opacity: 1,
              },
            },
          }}
          series={series}
          type="rangeBar"
          height={calculateRemainingHeight(300)}
        />
      )}
    </div >
  );
};;